import { axios } from '@/services/axios';

export const getTRSCluster = (clusterId) => {
    const endpoint = `/TRSCluster/${clusterId}`;
    const res = axios.get(endpoint);
    return res;
};
